export const REQUEST_START = "REQUEST_START";
export const FETCH_COMMENTS = "FETCH_COMMENTS";
export const REQUEST_ERROR = "REQUEST_ERROR";
export const COMMENT_SAVED = "COMMENT_SAVED";
export const SET_COMMENTS = "SET_COMMENTS";
export const RESET_COMMENTS = "RESET_COMMENTS";
export const COMMENT_DELETED = "COMMENT_DELETED";
